module.exports = __webpack_public_path__ + "static/media/Driver Trainings DEC.ba38585d.csv";